export default {
  home: '首页',
  services: '服务分类',
  articles: '体育资讯',
  about: '关于我们',
  contact: '联系我们',
  viewAll: '查看全部',
  readMore: '了解更多',
  submit: '提交',
  loading: '加载中...',
  backHome: '返回首页',
  backToList: '返回列表',
  hotEvents: '精选赛事',
  hotProducts: '热门商品',
  hotCourses: '热门课程',
  partners: '合作伙伴',
  faq: '常见问题',
  footer_slogan: '专业体育服务平台',
  breadcrumb_home: '首页',
  contact_us: '联系我们',
  online_message: '在线留言',
  name: '姓名',
  email: '邮箱',
  phone: '电话',
  message: '留言内容',
  submit_message: '提交留言',
  submitting: '提交中...',
  submit_success: '感谢您的留言，我们会尽快与您联系！',
  submit_error: '提交失败，请稍后重试。',
  network_error: '网络错误，请稍后重试。',
};